import React from "react";

const OpenCameraComponent = ({
  isCameraLoading,
  videoRef,
  capturePhoto,
  closeCamera,
}) => {
  console.log("IscameraLoading", isCameraLoading);
  return (
    <div className=" fixed w-full flex justify-center items-center inset-0 z-50 bg-[black]/50 backdrop-blur-sm mt-4">
      <div className="bg-primarybgColor p-4 rounded-lg">
        {isCameraLoading && (
          <div className="">Loading your camera, please wait...</div>
        )}
        <video
          ref={videoRef}
          className="w-full h-auto rounded-lg"
          autoPlay
          playsInline
          muted
        />
        {!isCameraLoading && (
          <div className="flex justify-between items-center mt-2">
            <button
              type="button"
              onClick={capturePhoto}
              disabled={isCameraLoading}
              className="bg-primaryBtnColor hover:bg-primaryBtnHoverColor text-white px-4 py-2 rounded"
            >
              Capture Photo
            </button>
            <button
              type="button"
              onClick={closeCamera}
              disabled={isCameraLoading}
              className="bg-white hover:bg-secondaryTextColor text-primaryTextColor px-4 py-2 rounded"
            >
              Close Camera
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OpenCameraComponent;
